module.exports = __webpack_public_path__ + "static/media/Contact.559ac82e.png";